"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTypeEnum = void 0;
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["PortfolioValueChanged"] = "portfolioValueChanged";
    NotificationTypeEnum["PortfolioMilestoneReached"] = "portfolioMilestoneReached";
    NotificationTypeEnum["DividendPayment"] = "dividendPayment";
})(NotificationTypeEnum = exports.NotificationTypeEnum || (exports.NotificationTypeEnum = {}));
//# sourceMappingURL=notification-type-enum.js.map